module.exports = __webpack_public_path__ + "static/media/share-white.15f4e901.svg";